import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const LOGIN_FIELD_NAME = 'login';
const LOGIN_MAX_LENGTH = 255;

export type LoginFormBeanPart = { [LOGIN_FIELD_NAME]: string | null };

type LoginFieldProps = Pick<FormContextValues<LoginFormBeanPart>, 'register'>;

export const LoginField = (props: LoginFieldProps): JSX.Element => {
   const controller = props.register(LOGIN_FIELD_NAME, { required: true, maxLength: LOGIN_MAX_LENGTH });

   return <TextInput label={nfzLoginTranslationKeys.nfzLogin} controller={controller} testId={'login'} />;
};
